import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { baseApi } from "@api/baseApi";
import { getRedirectAfterWaitingRoom } from "./waitingRoomGuard";

/**
 * Cierra el onboarding a partir de la sala de espera (CSCOF): si la solicitud ya llegó ahí y el
 * usuario intenta volver a una pantalla anterior (botón "atrás" del navegador o url a mano), lo
 * regresa a la pantalla de su status actual. Las demás rutas pasan sin cambios.
 */
const ProtectRouteAfterWaitingRoom = () => {
  const { pathname } = useLocation();
  const statusConfig = useSelector((state: RootState) => state.app.status_config);
  const loanStatus = useSelector((state: RootState) => state.register.loan_status);
  // `postValidateNextStage` pone el status nuevo en cuanto sale la petición. Mientras no responda, no se redirige:
  // si termina bien, la pantalla navega sola; si falla, el status regresa al anterior y el usuario se queda donde está.
  const isChangingStatus = useSelector((state: RootState) =>
    Object.values(state[baseApi.reducerPath].mutations).some(
      (mutation) => mutation?.endpointName === "postValidateNextStage" && mutation.status === "pending",
    ),
  );

  const redirect = isChangingStatus ? null : getRedirectAfterWaitingRoom(statusConfig, loanStatus, pathname);
  if (redirect) return <Navigate to={redirect} replace />;

  return <Outlet />;
};

export default ProtectRouteAfterWaitingRoom;
